export const SEARCH_PAGE_SIZE = 20;
export const SEARCH_TYPES = ["accounts", "statuses", "hashtags"];

export function createSearchResults(results) {
  const search = { pages: {}, activeType: "accounts" };
  for (const type of SEARCH_TYPES) {
    search[type] = [];
    search.pages[type] = { offset: 0, hasMore: true, loading: false, error: false };
    appendSearchPage(search, type, results[type] || []);
  }
  return search;
}

export function appendSearchPage(search, type, rows) {
  const key = row => type === "hashtags" ? row.name.toLowerCase() : row.id;
  const known = new Set(search[type].map(key));
  let added = 0;
  for (const row of rows) {
    const id = key(row);
    if (known.has(id)) continue;
    known.add(id);
    search[type].push(row);
    added += 1;
  }
  const page = search.pages[type];
  // Advance by the raw page size, even if shifting results overlapped a
  // previous page. Stop on repeated pages from servers that ignore offset.
  page.offset += rows.length;
  page.hasMore = rows.length >= SEARCH_PAGE_SIZE && added > 0;
  page.error = false;
}
